// extracted by mini-css-extract-plugin
export default {"card":"Card_card__6tlgb","hoverable":"Card_hoverable__tkg-t","header":"Card_header__r6TGY","title":"Card_title__pjsIf","content":"Card_content__fdWti","footer":"Card_footer__xh5Q6"};